export const SECTION_ABOUT_BUSINESS = 'aboutBusinessSection';
export const SECTION_BRAND_SELECTION = 'brandSelectionSection';
export const SECTION_BUSINESS_ADDRESS = 'businessAddressSection';
export const SECTION_CANDIDATE_SEARCH_RESULTS = 'candidateSearchResultsSection';
export const SECTION_JOB_AD_REFERENCE = 'jobAdReferenceSection';
export const SECTION_WRITE_ABOUT_YOUR_JOB = 'writeAboutYourJobSection';
export const SECTION_JOB_SUMMARY = 'jobSummarySection';
export const SECTION_KEY_SELLING_POINTS = 'keySellingPointsSection';
export const SECTION_LINKOUT = 'linkOutSection';
export const SECTION_PAY_AND_POST = 'payAndPostSection';
export const SECTION_PAY_DETAILS = 'payDetailsSection';
export const SECTION_PRIVATE_AD = 'privateAdSection';
export const SECTION_CLASSIFY = 'classifySection';
export const SECTION_STO_UPSELL = 'stoUpSellSection';
export const SECTION_UPSELL = 'upsellSection';
export const SECTION_BOOK_A_CALL = 'bookACallSection';
